import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { PortalLayout } from "@/layouts/PortalLayout";

// Marketing
import { HomePage } from "@/pages/marketing/HomePage";
import { ContactPage } from "@/pages/marketing/ContactPage";

// Portal — Membre
import { MemberLoginPage } from "@/pages/portal/MemberLoginPage";
import { MemberDashboardPage } from "@/pages/portal/MemberDashboardPage";
import { MemberFormPage } from "@/pages/portal/MemberFormPage";
import { PaymentPage } from "@/pages/portal/PaymentPage";
import { LinkPaymentPage } from "@/pages/portal/LinkPaymentPage";
import { CompletionPage } from "@/pages/portal/CompletionPage";
import { JoinPage } from "@/pages/portal/JoinPage";
import { CommunityPickerPage } from "@/pages/portal/CommunityPickerPage";

// Admin
import { AdminLoginPage } from "@/pages/auth/AdminLoginPage";
import { AdminRegisterPage } from "@/pages/auth/AdminRegisterPage";
import { AdminSetupPage } from "@/pages/auth/AdminSetupPage";
import { AdminForgotPasswordPage } from "@/pages/auth/AdminForgotPasswordPage";
import { SuperAdminPage } from "@/pages/app/SuperAdminPage";
import { StripeOnboardingPage } from "@/pages/app/StripeOnboardingPage";
import { AppLayout } from "@/layouts/AppLayout";
import { DashboardPage } from "@/pages/app/admin/DashboardPage";
import { MembersPage } from "@/pages/app/admin/MembersPage";
import { PaymentsPage } from "@/pages/app/admin/PaymentsPage";
import { SinistresPage } from "@/pages/app/admin/SinistresPage";
import { FinancePage } from "@/pages/app/admin/FinancePage";
import { ParametresPage } from "@/pages/app/admin/ParametresPage";

const isAdminAuthenticated = () =>
  Boolean(localStorage.getItem("hafani_admin_token"));

const getAdminRole = () =>
  localStorage.getItem("hafani_admin_role") || "";

const AdminRoute = ({ children }) =>
  isAdminAuthenticated() ? children : <Navigate to="/admin/login" replace />;

const SuperAdminRoute = ({ children }) => {
  if (!isAdminAuthenticated()) return <Navigate to="/admin/login" replace />;
  if (getAdminRole() !== "super_admin") return <Navigate to="/app/dashboard" replace />;
  return children;
};

const isMemberAuthenticated = () =>
  Boolean(localStorage.getItem("hafani_member_token"));

const MemberRoute = ({ children }) =>
  isMemberAuthenticated() ? children : <Navigate to="/login" replace />;

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Marketing */}
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/adhesion" element={<Navigate to="/login" replace />} />
          <Route path="/associations" element={<Navigate to="/" replace />} />

          {/* Authentification membre */}
          <Route path="/login" element={<MemberLoginPage />} />

          {/* Lien de paiement adhérent — public, jeton opaque */}
          <Route path="/paiement/:token" element={<LinkPaymentPage />} />

          {/* Espace membre protégé */}
          <Route path="/choisir-communaute" element={<MemberRoute><CommunityPickerPage /></MemberRoute>} />
          <Route path="/dashboard" element={<MemberRoute><MemberDashboardPage /></MemberRoute>} />
          <Route element={<PortalLayout />}>
            <Route path="/mon-dossier" element={<MemberRoute><MemberFormPage /></MemberRoute>} />
            <Route path="/paiement" element={<MemberRoute><PaymentPage /></MemberRoute>} />
            <Route path="/confirmation" element={<MemberRoute><CompletionPage /></MemberRoute>} />
            <Route path="/join" element={<JoinPage />} />
          </Route>

          {/* Admin — auth */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/register" element={<AdminRegisterPage />} />
          <Route path="/admin/setup" element={<AdminSetupPage />} />
          <Route path="/admin/forgot-password" element={<AdminForgotPasswordPage />} />

          {/* Admin — app */}
          <Route element={<AdminRoute><AppLayout /></AdminRoute>}>
            <Route path="/app/dashboard" element={<DashboardPage />} />
            <Route path="/app/membres" element={<MembersPage />} />
            <Route path="/app/paiements" element={<PaymentsPage />} />
            <Route path="/app/sinistres" element={<SinistresPage />} />
            <Route path="/app/finance" element={<FinancePage />} />
            <Route path="/app/parametres" element={<ParametresPage />} />
          </Route>
          <Route path="/app/stripe-onboarding" element={<AdminRoute><StripeOnboardingPage /></AdminRoute>} />
          <Route path="/admin/super" element={<SuperAdminRoute><SuperAdminPage /></SuperAdminRoute>} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
